var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCpaProduct } from 'components/Cpa/CpaProduct/CpaProductContextProvider';
import { PubTable } from 'components/Shared/PubTable/PubTable';
import { InputFieldType } from 'models/Input/InputModels';
import Box from '@mui/material/Box';
import { debounce } from '@mui/material/utils';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import { BannerIconType, BannerMessageType, useBanner } from 'components/Shared/BannerContext/BannerContext';
import { useEffect, useMemo, useState } from 'react';
import { arrayMove } from 'utils/utils';
import { createLock, checkUserLockPreventsEdit } from 'utils/cpa-utils';
import { CPA_DEFAULT_STEP_NO, DEVIATION_MAX_LENGTH, IMPLIED_FEATURE_TYPE } from 'utils/constants';
import { PubInputField } from 'components/Shared/PubInputField/PubInputField';
import { getUserOrSignIn } from 'services/auth/AuthService';
export function DescriptionFeaturesTable(_a) {
    var _this = this;
    var _b;
    var _c = _a.showAddRow, showAddRow = _c === void 0 ? false : _c, _d = _a.showAddRowAction, showAddRowAction = _d === void 0 ? function () { return null; } : _d;
    var cpaProduct = useCpaProduct();
    var _e = useState(), deviationDesc = _e[0], setDeviationDesc = _e[1];
    var _f = useBanner(), setBannerMessage = _f.setBannerMessage, setBannerType = _f.setBannerType, setBannerIcon = _f.setBannerIcon, setShowBanner = _f.setShowBanner, setIsRefreshEnabled = _f.setIsRefreshEnabled;
    useEffect(function () {
        var _a;
        setDeviationDesc((_a = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) === null || _a === void 0 ? void 0 : _a.deviationDesc);
    }, [(_b = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) === null || _b === void 0 ? void 0 : _b.deviationDesc]);
    var featureTableData = mapTableArrayToObject();
    var tableDataDefinition = {
        rowDecorator: {
            value: 'DEVIATED',
            hide: function (row) { return !row.devInd; },
            color: '#017a9a'
        },
        columns: [
            {
                dataAttribute: 'rowNo',
                fieldType: InputFieldType.NUMBER,
                heading: 'Row',
                width: '100px',
                showHelpTooltip: true,
                validations: {
                    required: 'Required field.',
                    numberOnly: 'Invalid input. Only numbers allowed.',
                },
            },
            {
                dataAttribute: 'featureDescription',
                fieldType: InputFieldType.STRING,
                heading: 'Feature Name',
                width: '300px',
                showHelpTooltip: true,
                validations: {
                    required: 'Feature Name is required.',
                    maxLength: 255,
                },
            },
            {
                dataAttribute: 'optionCode',
                fieldType: InputFieldType.STRING,
                heading: 'Option Code',
                width: '200px',
                showHelpTooltip: true,
                validations: {
                    noSpaces: 'Invalid input. No spaces allowed.',
                    maxLength: 20,
                },
            },
            {
                dataAttribute: 'optionDescription',
                fieldType: InputFieldType.STRING,
                heading: 'Option Description',
                showHelpTooltip: true,
                validations: {
                    required: 'Option Description is required.',
                    maxLength: 500,
                },
            },
        ],
        addRowWhenNoData: false,
        showAddRow: showAddRow,
        showAddRowHandler: showAddRowAction,
        disableEdit: function (_key) { return checkUserLockPreventsEdit(cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.cpn); },
        editHandler: function (key, newRow, oldRow) { return __awaiter(_this, void 0, void 0, function () {
            var rowChanged, newRowNo, newRowIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        rowChanged = isRowChanged(newRow, oldRow);
                        if (!rowChanged) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleCreateLock()];
                    case 1:
                        _a.sent();
                        newRowNo = newRow.rowNo;
                        newRow.devInd = true;
                        delete newRow.rowNo;
                        if (+key === newRowNo) {
                            cpaProduct.data.currentProduct.featureOptions[key - 1] = newRow;
                        }
                        else {
                            newRowIndex = getNewRowIndex(newRowNo, key, cpaProduct.data.currentProduct.featureOptions.length);
                            arrayMove(cpaProduct.data.currentProduct.featureOptions, key - 1, newRowIndex);
                            resetFeatureSequences();
                        }
                        dispatchUpdateCurrentProduct();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        extraIcon: {
            icon: _jsx(RemoveCircleOutlineIcon, {}),
            handler: function (key) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            cpaProduct.data.currentProduct.featureOptions[key - 1].devInd = false;
                            dispatchUpdateCurrentProduct();
                            return [4 /*yield*/, handleCreateLock()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            hide: function (row) { return !row.devInd; },
        },
        addHandler: function (newRow) { return __awaiter(_this, void 0, void 0, function () {
            var newRowNo, newRowIndex;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        newRowNo = newRow.rowNo;
                        newRow.devInd = true;
                        newRowIndex = newRowNo > cpaProduct.data.currentProduct.featureOptions.length
                            ? cpaProduct.data.currentProduct.featureOptions.length
                            : newRowNo - 1;
                        delete newRow.rowNo;
                        (_a = cpaProduct.data.currentProduct.featureOptions) === null || _a === void 0 ? void 0 : _a.splice(newRowIndex, 0, appendDefaultValues(newRow, newRowIndex));
                        resetFeatureSequences();
                        dispatchUpdateCurrentProduct();
                        return [4 /*yield*/, handleCreateLock()];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        deleteProps: {
            deleteHandler: function (key) { return __awaiter(_this, void 0, void 0, function () {
                var _a;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            (_a = cpaProduct.data.currentProduct.featureOptions) === null || _a === void 0 ? void 0 : _a.splice(Number(key) - 1, 1);
                            dispatchUpdateCurrentProduct();
                            return [4 /*yield*/, handleCreateLock()];
                        case 1:
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }); },
            disabled: cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.isEditDisabled,
            modalProps: {
                buttonProps: { confirmText: 'Delete Characteristic', cancelText: 'Keep Characteristic' },
                bodyTextArray: ['Are you sure you would like to delete this characteristic? This action is permanent.'],
                titleText: 'Delete Characteristic',
            },
        },
    };
    function isRowChanged(newRow, oldRow) {
        var rowChanged = false;
        if (newRow.featureDescription !== oldRow.featureDescription ||
            newRow.rowNo !== oldRow.rowNo ||
            newRow.optionCode !== oldRow.optionCode ||
            newRow.optionDescription !== oldRow.optionDescription) {
            rowChanged = true;
        }
        return rowChanged;
    }
    function resetFeatureSequences() {
        var _a;
        (_a = cpaProduct.data.currentProduct.featureOptions) === null || _a === void 0 ? void 0 : _a.forEach(function (el, i) {
            el.featureSequence = String((i + 1) * 100);
        });
    }
    function dispatchUpdateCurrentProduct() {
        cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.dispatch({
            type: 'UPDATE_CURRENT_PRODUCT',
            payload: __assign({}, cpaProduct.data.currentProduct),
        });
    }
    function handleCreateLock() {
        return __awaiter(this, void 0, void 0, function () {
            var cpn, sessionId, user, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cpn = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.cpn;
                        sessionId = sessionStorage.getItem("".concat(cpn, "_identifier"));
                        if (!(cpn && sessionId)) return [3 /*break*/, 5];
                        return [4 /*yield*/, getUserOrSignIn()];
                    case 1:
                        user = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, createLock(cpn, user.name, sessionId, cpaProduct.data.currentProduct.startDate)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        setBannerMessage("This record is locked because it's currently being edited by somone else. Please reload by clicking here: ");
                        setBannerType(BannerMessageType.Warning);
                        setBannerIcon(BannerIconType.Error);
                        setShowBanner(true);
                        setIsRefreshEnabled(true);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function getNewRowIndex(newRowNo, oldRowNo, totalLength) {
        var newRowIndex;
        if (newRowNo > totalLength) {
            newRowIndex = totalLength - 1;
        }
        else if (newRowNo <= 0) {
            newRowIndex = 0;
        }
        else if (newRowNo > oldRowNo) {
            newRowIndex = newRowNo - 2;
        }
        else {
            newRowIndex = newRowNo - 1;
        }
        return newRowIndex;
    }
    function mapTableArrayToObject() {
        var _a, _b, _c;
        return ((_a = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) === null || _a === void 0 ? void 0 : _a.featureOptions)
            ? (_c = (_b = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) === null || _b === void 0 ? void 0 : _b.featureOptions) === null || _c === void 0 ? void 0 : _c.reduce(function (agg, el, index) {
                var _a;
                return (__assign(__assign({}, agg), (_a = {}, _a[index + 1] = __assign({ rowNo: index + 1 }, el), _a)));
            }, {})
            : {};
    }
    function appendDefaultValues(newRow, index) {
        var date = new Date();
        var epoch = date.getTime().toString();
        return __assign(__assign({}, newRow), { featureId: "implied-".concat(date.toTimeString().slice(0, 8).replaceAll(':', '')).concat(epoch.slice(epoch.length - 3, epoch.length)), step: CPA_DEFAULT_STEP_NO, type: IMPLIED_FEATURE_TYPE, skuSelection: false, nonStandardIndicator: false, multipleSelection: '0', optionSequence: 1, featureSequence: String((index + 1) * 100) });
    }
    var updateDeviationInContextDebouced = useMemo(function () {
        return debounce(function (updatedValue) {
            cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.dispatch({
                type: 'UPDATE_DEVIATION_DESC',
                payload: updatedValue,
            });
        }, 500);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var createLockDebounced = useMemo(function () {
        return debounce(function (updatedValue) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(((_a = cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) === null || _a === void 0 ? void 0 : _a.deviationDesc) !== updatedValue)) return [3 /*break*/, 2];
                        return [4 /*yield*/, handleCreateLock()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); }, 500);
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return (featureTableData && (_jsxs(_Fragment, { children: [(cpaProduct === null || cpaProduct === void 0 ? void 0 : cpaProduct.data.currentProduct) && (_jsx(Box, __assign({ width: "25%" }, { children: _jsx(PubInputField, { fieldType: InputFieldType.STRING, fieldValue: deviationDesc, labels: {
                        left: 'Deviations',
                        right: 'Required',
                    }, validations: {
                        required: 'Please enter value.',
                        maxLength: DEVIATION_MAX_LENGTH,
                    }, fieldPlaceholderText: "Enter Deviation Notes Here", multipRows: 2, fieldValueUpdateHandler: function (val) {
                        setDeviationDesc(val);
                        updateDeviationInContextDebouced(val);
                        createLockDebounced(val);
                    }, disabled: cpaProduct.data.isEditDisabled }) }))), _jsx(PubTable, { def: tableDataDefinition, tableData: featureTableData })] })));
}
